import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["action"];
import { LayoutGridAuto, LayoutHorizontal } from 'breeze-intelligence-kit';
import { useEnrichmentCredits } from '../EnrichmentCreditsProvider';
import { UsageCreditsOverage } from './UsageCreditsOverage';
import { UsageCreditsUsed } from './UsageCreditsUsed';
import { UsageError } from './UsageError';
import { useEnrichmentPolicyNext } from '../EnrichmentPolicy/useEnrichmentPolicyNext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const UsageSection = _ref => {
  let {
      action
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    hasError,
    hasLowCredits,
    isLoading,
    resetDays,
    showOverage,
    totalOverage,
    totalUsage,
    usageLimit,
    onRefresh
  } = useEnrichmentCredits();
  const {
    includedAction
  } = useEnrichmentPolicyNext();
  if (includedAction(action)) {
    return null;
  }
  if (hasError) {
    return /*#__PURE__*/_jsx(UsageError, {
      onRefresh: onRefresh
    });
  }
  if (showOverage) {
    return /*#__PURE__*/_jsxs(LayoutGridAuto, Object.assign({}, rest, {
      alignItems: "stretch",
      autoRepeat: "auto-fit",
      gap: "space-sm",
      minBlockSize: "6.5rem",
      minWidth: "10rem",
      children: [/*#__PURE__*/_jsx(UsageCreditsUsed, {
        hasLowCredits: hasLowCredits,
        isLoading: isLoading,
        resetDays: resetDays,
        totalUsage: totalUsage,
        usageLimit: usageLimit
      }), /*#__PURE__*/_jsx(UsageCreditsOverage, {
        credits: totalOverage,
        isLoading: isLoading
      })]
    }));
  }
  return /*#__PURE__*/_jsx(LayoutHorizontal, Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx(UsageCreditsUsed, {
      hasLowCredits: hasLowCredits,
      isLoading: isLoading,
      minBlockSize: "6.5rem",
      resetDays: resetDays,
      totalUsage: totalUsage,
      usageLimit: usageLimit
    })
  }));
};